import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentSelectOrdersInstructionsModal() {
  const storage = useStorage();
  const { spot } = storage;
  const { analyticsPageView } = useAnalytics();
  const { swal } = useSwal({ storage });

  const didOpen = () => {
    analyticsPageView('Payment Select Instructions');
  };

  async function show() {
    const result = await swal.fire({
      title: spot?.prepaid ? `Escolha os Itens` : `Escolha os Pedidos`,
      text: `Toque nos que você quer pagar`,
      icon: 'info',
      confirmButtonText: 'Ok',
      didOpen,
    });

    result.showSelectInstructions = true;
    return result;
    // return { showSelectInstructions: true };
  }

  return {
    showPaymentSelectOrdersInstructionsModal: show,
  };
}

export { usePaymentSelectOrdersInstructionsModal };
